import HashManager from 'assets/core/js/module/hashManager'
import { PartialsLoadingEvents } from 'assets/themes/campings/js/module/partials'

export const scrollToAccommodation = function (callback?: (partialEl: HTMLElement, anchor: string) => void): void {
  const partialEl = document.querySelector<HTMLElement>('[data-partial-id="results"]')
  const anchor = HashManager.getAnchor()

  if (!partialEl || !anchor) {
    return
  }

  if (Object.keys(HashManager.getParameters()).length === 0) {
    callback?.(partialEl, anchor)

    setTimeout(() => {
      HashManager.goToAnchor(anchor)
    }, 0)
    return
  }

  partialEl.addEventListener(
    PartialsLoadingEvents.HIDDEN,
    () => {
      callback?.(partialEl, anchor)

      setTimeout(() => {
        HashManager.goToAnchor(anchor)
      }, 0)
    },
    { once: true }
  )
}
